import { Component,OnInit, ElementRef, ViewChild, Renderer2, HostListener, PLATFORM_ID, Inject  } from '@angular/core';
import * as AOS from 'aos';
import Swiper from 'swiper'; 
import { ActivatedRoute, Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { Constants } from '../../common/constants';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-cloudservices',
  templateUrl: './cloudservices.component.html',
  styleUrls: ['./cloudservices.component.css']
})
export class CloudservicesComponent implements OnInit{
  isBrowser:boolean=false;

    baseUrl=Constants.baseUrl;
    constructor(
        private titleService: Title,  @Inject(PLATFORM_ID) private platformId: any,
        private _renderer2: Renderer2,private seoService:SeoService,
        @Inject(DOCUMENT) private _document: Document,private router: Router,
        private metaService: Meta
      ) {this.isBrowser=isPlatformBrowser(this.platformId);}
ngOnInit(){
  
  let script = this._renderer2.createElement('script');
      script.type = `application/ld+json`;
      script.text = `

{
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/cloudservices/"
  },
  "headline": "Cloud Hosting & Cloud Computing Services | Maganti IT",
  "description": "Managing today's extensive cloud infrastructure demands modern IT operations that seamlessly integrate infrastructure, data, and applications to support a resilient digital enterprise.",
  "image": "https://mitresource.com/assets/images/homepage/CaseStudies-imd-1.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-10-28"

}`;
     
      this._renderer2.appendChild(this._document.head, script);
  
  
  if(this.isBrowser){     
  AOS.init({disable: 'mobile', duration: 2000, delay: 500,});
  const showImagesButton: HTMLElement | null = document.getElementById('showImagesButton');

  showImagesButton?.classList.add('active-button'); 
        function handleButtonClick() {
            // Get references to the buttons and containers
            const showImagesButton: HTMLElement | null = document.getElementById('showImagesButton');
            const showImages2Button: HTMLElement | null = document.getElementById('showImages2Button');
            const imageContainer1: HTMLElement | null = document.getElementById('image-container1');
            const imageContainer2: HTMLElement | null = document.getElementById('image-container2');
        
            // Check if any of the elements are null
            if (showImagesButton && showImages2Button && imageContainer1 && imageContainer2) {
                // Add event listener for the first button
                showImagesButton.addEventListener('click', function() {
                    // Show the first container and hide the second one
                    imageContainer1.style.display = 'block';
                    imageContainer2.style.display = 'none';
                    
                    // Update button styles
                    showImagesButton.classList.remove('inactive-button');
                    showImagesButton.classList.add('active-button');
                    showImages2Button.classList.remove('active-button');
                    showImages2Button.classList.add('inactive-button');
                });
        
                // Add event listener for the second button
                showImages2Button.addEventListener('click', function() {
                    // Show the second container and hide the first one
                    imageContainer1.style.display = 'none';
                    imageContainer2.style.display = 'block';
                    
                    // Update button styles
                    showImages2Button.classList.remove('inactive-button');
                    showImages2Button.classList.add('active-button');
                    showImagesButton.classList.remove('active-button');
                    showImagesButton.classList.add('inactive-button');

                });
        
                // Initialize with the first button as active
                showImagesButton.click();
            } else {
                // console.error('One or more elements could not be found in the DOM.');
            }
        }
        
        // Call the function to set up event listeners
        handleButtonClick();
        
    }  
    
this.setTitleAndMetaTags();
this.seoService.createLinkForCanonicalURL();
}
private setTitleAndMetaTags(): void {
    // Set page title
    this.titleService.setTitle('Cloud Hosting & Cloud Computing Services | Maganti IT');

    // Set meta tags
    this.metaService.addTags([
      { name: 'description', content: 'Bring your business into the cloud with customized cloud hosting services and cloud computing solutions including private, public and hybrid cloud services.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Cloud Hosting & Cloud Computing Services | Maganti IT' },
      { property: 'og:url', content: 'https://mitresource.com/cloudservices/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/homepage/CaseStudies-imd-1.png' },
      { property: 'og:description', content: 'Bring your business into the cloud with customized cloud hosting services and cloud computing solutions including private, public and hybrid cloud services' },
    ]);
  }
  

  @ViewChild('testimonialCarousel') testimonialCarousel!: ElementRef;

  scrollToSection(sectionId: string): void {
    const section = document.querySelector(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  }
  title = 'app';


}
